import React, { useEffect } from "react";
import { Form, Input, InputNumber } from "antd";
import svg153 from "../../../../assets/svg/svg153.svg";
import svg154 from "../../../../assets/svg/svg154.svg";
import { numberWithCommas } from "../../../../utils";

function AmountToPay({ amount, form }) {
  const editableAmount = Form.useWatch("editableAmount", form);
  const displayAmount = editableAmount || amount;

  useEffect(() => {
    if (amount) {
      form.setFieldsValue({ editableAmount: amount });
    }
  }, [amount, form]);

  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] mt-[1rem]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[0.5rem]">
          <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-surface2 flex items-center justify-center">
            <img src={svg153} alt="svg153" />
          </div>
          <span className="text-ink font-[400] font-lexendS text-[1rem] leading-[1.5rem]">
            Amount to Pay
          </span>
        </div>

        <div className="flex items-center gap-[0.44rem] rounded-[624.9375rem] py-[0.125rem] px-[0.5rem] bg-surface2">
          <img src={svg154} alt="svg154" className="w-[0.75rem] h-[0.75rem]" />
          <span className="text-body text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
            Min 15
          </span>
        </div>
      </div>

      <div className="flex justify-between items-center mb-[0.75rem] ] mt-[1rem]">
        <div className="text-body font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
          Amount Due
        </div>

        <div className="text-ink font-lexendS text-[0.875rem] font-[500] leading-[1.5rem]">
          KES {numberWithCommas(displayAmount)}
        </div>
      </div>

      <Form.Item
        label="Enter Amount (KES)"
        name="editableAmount"
        initialValue={amount}
        className="mt-[.88rem]"
      >
        <InputNumber
          min={15}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>
    </div>
  );
}

export default AmountToPay;
